/* Pluto design system (round 17): mode switch, accordions, tabs, rails,
   plan picker, sticky bar and scroll reveals. No libraries. */
(function () {
  'use strict';
  /* touch or pen taps never draw keyboard focus rings on the big invisible tap zones; Tab brings them back */
  document.addEventListener('pointerdown', function (e) { if (e.pointerType && e.pointerType !== 'mouse') document.documentElement.classList.add('pl-touch'); }, { passive: true });
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') document.documentElement.classList.remove('pl-touch'); });
  var doc = document, root = doc.documentElement, KEY = 'pl-mode';
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  var motionOK = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---- Daylight / Night ------------------------------------------- */
  function isNight() { return root.getAttribute('data-mode') === 'night'; }
  function paintControls() {
    var night = isNight();
    $$('[data-mode-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', String(night)); });
    $$('[data-set-mode]').forEach(function (b) {
      b.setAttribute('aria-pressed', String((b.getAttribute('data-set-mode') === 'night') === night));
    });
  }
  function setMode(mode) {
    root.setAttribute('data-mode', mode);
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    paintControls();
  }
  function warmNight() {
    $$('img.shot.night[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-mode-toggle],[data-set-mode]') : null;
    if (!t) return;
    if (t.hasAttribute('data-set-mode')) setMode(t.getAttribute('data-set-mode'));
    else setMode(isNight() ? 'day' : 'night');
  });
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
    doc.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest('[data-mode-toggle],[data-set-mode]')) warmNight();
    }, { passive: true, capture: true });
  });
  paintControls();

  /* ---- Accordions: aria-expanded on the button, answer stays in the HTML */
  doc.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('[data-acc] button.q') : null;
    if (!q) return;
    var item = q.closest('.item');
    var open = !item.classList.contains('open');
    item.classList.toggle('open', open);
    q.setAttribute('aria-expanded', String(open));
  });
  $$('[data-showall]').forEach(function (b) {
    var acc = doc.getElementById(b.getAttribute('aria-controls'));
    if (!acc) return;
    var more = b.textContent.trim(), less = b.getAttribute('data-less') || 'Show fewer';
    b.addEventListener('click', function () {
      var on = !acc.classList.contains('showall');
      acc.classList.toggle('showall', on);
      b.setAttribute('aria-expanded', String(on));
      b.textContent = on ? less : more;
      if (on) {
        var first = acc.querySelector('.item.extra button.q');
        if (first) first.focus({ preventScroll: true });
      }
    });
  });
  /* open an answer that a link points at, e.g. #faq-3 */
  function openFromHash() {
    var id = location.hash.slice(1);
    if (!id) return;
    var el = doc.getElementById(id);
    if (!el || !el.classList.contains('item')) return;
    var acc = el.closest('[data-acc]');
    if (el.classList.contains('extra') && acc) acc.classList.add('showall');
    el.classList.add('open');
    var q = el.querySelector('button.q');
    if (q) q.setAttribute('aria-expanded', 'true');
  }

  /* ---- Tabs, with #for-him style deep links ------------------------ */
  function selectTab(tab, focus) {
    var list = tab.closest('[role="tablist"]');
    $$('[role="tab"]', list).forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      var p = doc.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (focus) tab.focus();
  }
  $$('.pl-tabs [role="tablist"]').forEach(function (list) {
    var tabs = $$('[role="tab"]', list);
    list.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) return;
      selectTab(t);
      var h = t.getAttribute('data-hash');
      if (h && history.replaceState) history.replaceState(null, '', '#' + h);
    });
    list.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(doc.activeElement), n = tabs.length, j = -1;
      if (i < 0) return;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault();
      selectTab(tabs[j], true);
    });
  });
  function tabFromHash() {
    var h = location.hash.slice(1);
    if (!h) return;
    var t = doc.querySelector('.pl-tabs [role="tab"][data-hash="' + h.replace(/"/g, '') + '"]');
    if (!t) return;
    selectTab(t);
    var sec = t.closest('.pl');
    if (sec) sec.scrollIntoView({ block: 'start' });
  }
  window.addEventListener('hashchange', function () { tabFromHash(); openFromHash(); });

  /* ---- Chips ------------------------------------------------------- */
  doc.addEventListener('click', function (e) {
    var c = e.target.closest ? e.target.closest('.pl-chip') : null;
    if (!c) return;
    var group = c.closest('[data-chips]');
    if (group && group.getAttribute('data-chips') === 'one') {
      $$('.pl-chip', group).forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
    } else {
      c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed') !== 'true'));
    }
  });

  /* ---- Plan picker: the button follows the pick -------------------- */
  $$('[data-plan]').forEach(function (form) {
    var go = form.querySelector('[data-plan-go]');
    function sync() {
      $$('label', form).forEach(function (l) {
        var r = l.querySelector('input');
        l.classList.toggle('on', !!(r && r.checked));
        if (r && r.checked && go) go.href = r.getAttribute('data-url');
      });
    }
    form.addEventListener('change', sync);
    sync();
  });

  /* ---- Swipe rails: dots follow the scroll ------------------------- */
  $$('[data-rail]').forEach(function (rail) {
    /* a swipe rail with nothing focusable inside gets a tab stop, so keyboards can scroll it */
    if (rail.scrollWidth > rail.clientWidth + 2 && !rail.querySelector('a,button,input,[tabindex]')) {
      var h = rail.closest('section') && rail.closest('section').querySelector('h2[id]');
      rail.tabIndex = 0;
      if (!/^(OL|UL)$/.test(rail.tagName)) rail.setAttribute('role', 'region');
      if (h) rail.setAttribute('aria-labelledby', h.id);
    }
    var dots = rail.parentNode.querySelector('[data-dots]');
    if (!dots) return;
    var d = $$('i', dots), items = rail.children, raf = 0;
    function update() {
      raf = 0;
      if (!items.length) return;
      var step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 1;
      var max = rail.scrollWidth - rail.clientWidth;
      var i = rail.scrollLeft >= max - 4 ? d.length - 1 : Math.round(rail.scrollLeft / Math.max(step, 1));
      d.forEach(function (x, k) { x.classList.toggle('on', k === Math.min(i, d.length - 1)); });
    }
    rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  });

  /* ---- Sticky bar: shows once the hero is gone --------------------- */
  var bar = doc.querySelector('.pl-sticky');
  var hero = doc.querySelector('[data-sticky-start]') || doc.querySelector('.pl-hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    var past = false, hidden = false;
    function paint() {
      var on = past && !hidden;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      root.classList.toggle('pl-sticky-on', on);
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { past = !en.isIntersecting && en.boundingClientRect.top < 0; });
      paint();
    }).observe(hero);
    var stops = $$('[data-sticky-stop]');
    if (stops.length) {
      var seen = new Set();
      /* the top of the screen sits under the header, so it doesn't count */
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
        hidden = seen.size > 0;
        paint();
      }, { rootMargin: '-90px 0px 0px 0px' });
      stops.forEach(function (s) { io.observe(s); });
    }
  }

  /* ---- Light scroll reveals: only below the fold, only with motion -- */
  if (motionOK && 'IntersectionObserver' in window) {
    var vh = window.innerHeight || 800;
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('rv-in');
        rio.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.pl [data-rv]').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      if (el.getAttribute('data-rv') === 'kids') el.classList.add('rv-kids');
      el.classList.add('rv-pre');
      rio.observe(el);
    });
  }

  /* ---- Orbit: the planet only moves when motion is welcome --------- */
  if (!motionOK) $$('svg.pl-orbit').forEach(function (svg) { if (svg.pauseAnimations) svg.pauseAnimations(); });

  /* ---- Ticker: moves only while the page scrolls, so nothing moves on its own */
  var tickers = $$('[data-ticker]');
  if (tickers.length && motionOK) {
    var tq = false;
    function tick() {
      tq = false;
      var vh = window.innerHeight || 800;
      tickers.forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (r.bottom < -50 || r.top > vh + 50) return;
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        $$('.pl-ticker__row', t).forEach(function (row) {
          var w = row.scrollWidth / 3, dir = +row.getAttribute('data-dir') || 1;
          var x = dir > 0 ? -p * w * 0.9 : -w + p * w * 0.9;
          row.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
        });
      });
    }
    window.addEventListener('scroll', function () { if (!tq) { tq = true; requestAnimationFrame(tick); } }, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* ---- Stats count up once, when they scroll in -------------------- */
  var counters = $$('[data-count]');
  if (counters.length && motionOK && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        var el = en.target, txt = el.textContent.trim();
        var m = txt.match(/^([^\d]*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
        if (!m) return;
        var pre = m[1], num = parseFloat(m[2].replace(/,/g, '')), suf = m[3];
        var dec = (m[2].split('.')[1] || '').length, t0 = 0, dur = 1100;
        function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
          el.textContent = pre + (num * e).toFixed(dec) + suf;
          if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---- Pick your form: one tap swaps the product in the orbit, and the main
     button, the sticky bar, the receipt and the product rail follow the pick ---- */
  $$('[data-pick]').forEach(function (grp) {
    var opts = $$('[data-pick-opt]', grp);
    var heroEl = grp.closest('.pl-hero');
    var shots = heroEl ? $$('[data-pick-stage] img', heroEl) : [];
    function pick(btn, focus) {
      opts.forEach(function (o) {
        var on = o === btn;
        o.setAttribute('aria-checked', String(on));
        o.tabIndex = on ? 0 : -1;
      });
      var i = +btn.getAttribute('data-i') || 0;
      shots.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      var url = btn.getAttribute('data-url'), cta = btn.getAttribute('data-cta');
      var name = btn.getAttribute('data-name'), price = btn.getAttribute('data-price'), handle = btn.getAttribute('data-handle');
      $$('[data-pick-cta]').forEach(function (a) { if (url) a.href = url; if (cta && a.getAttribute('data-pick-cta') !== 'href') a.textContent = cta; });
      $$('[data-pick-name]').forEach(function (el) { if (name) el.textContent = name; });
      $$('[data-pick-price]').forEach(function (el) { if (price) el.textContent = price; });
      $$('[data-pick-tile]').forEach(function (t) { t.classList.toggle('picked', t.getAttribute('data-pick-tile') === handle); });
      if (focus) btn.focus();
    }
    grp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick-opt]');
      if (b) pick(b);
    });
    grp.addEventListener('keydown', function (e) {
      var i = opts.indexOf(doc.activeElement), n = opts.length, j = -1;
      if (i < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault();
      pick(opts[j], true);
    });
    /* the rail marks the starting pick too */
    var first = opts.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0];
    if (first) $$('[data-pick-tile]').forEach(function (t) { t.classList.toggle('picked', t.getAttribute('data-pick-tile') === first.getAttribute('data-handle')); });
  });

  /* ---- Story player: plays only on screen, pauses on touch, focus or the
     button, never loops, and never plays on its own with reduced motion ---- */
  $$('[data-story]').forEach(function (st) {
    var track = st.querySelector('[data-story-track]');
    var cards = track ? $$('.pl-story__card', track) : [];
    var n = cards.length;
    if (n < 2) return;
    var bars = $$('.pl-story__bars i', st);
    var sec = st.closest('section');
    var index = sec ? $$('[data-story-go]', sec) : [];
    var live = st.querySelector('[data-story-live]');
    var pauseBtn = st.querySelector('[data-story-pause]');
    var auto = motionOK && st.getAttribute('data-autoplay') !== 'false';
    var idx = 0, inView = false, userPaused = false, held = false, focused = false, ended = false, syncing = 0;
    $$('[data-story-prev],[data-story-next],[data-story-pause]', st).forEach(function (b) { b.hidden = false; });
    if (!auto) { st.classList.add('static'); if (pauseBtn) pauseBtn.hidden = true; }
    function playing() { return auto && inView && !userPaused && !held && !focused && !ended && !doc.hidden; }
    function paint() {
      st.classList.toggle('paused', !playing());
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        pauseBtn.querySelector('.pl-vh').textContent = userPaused ? 'Play' : 'Pause';
        pauseBtn.classList.toggle('is-paused', userPaused);
      }
    }
    function setBars() {
      bars.forEach(function (b, k) {
        b.classList.remove('cur');
        b.classList.toggle('done', k < idx);
      });
      var cur = bars[idx];
      if (cur) { void cur.offsetWidth; cur.classList.add('cur'); }
      var tm = (cards[idx].className.match(/\bt-(\w+)/) || [])[1];
      st.setAttribute('data-tone', tm || 'ink');
      index.forEach(function (b, k) { if (k === idx) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
    }
    function go(i, announce) {
      i = Math.max(0, Math.min(n - 1, i));
      idx = i;
      ended = false;
      syncing = Date.now();
      track.scrollTo({ left: i * track.clientWidth, behavior: motionOK ? 'smooth' : 'auto' });
      setBars();
      if (announce && live) {
        var h = cards[i].querySelector('.tt');
        live.textContent = (i + 1) + ' of ' + n + (h ? ': ' + h.textContent.trim() : '');
      }
      paint();
    }
    /* tap right for next, left for back; a sideways swipe on the card does the same */
    var sx = null, sy = 0, swiped = false;
    $$('.pl-story__tap', st).forEach(function (z) {
      z.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; swiped = false; held = true; paint(); });
      z.addEventListener('pointerup', function (e) {
        held = false;
        if (sx !== null) {
          var dx = e.clientX - sx, dy = e.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            swiped = true;
            if (dx < 0) { if (idx < n - 1) go(idx + 1, true); } else go(idx - 1, true);
          }
        }
        sx = null; paint();
      });
      z.addEventListener('pointercancel', function () { held = false; sx = null; paint(); });
    });
    st.querySelector('[data-story-next]').addEventListener('click', function () { if (swiped) { swiped = false; return; } if (idx < n - 1) go(idx + 1, true); });
    st.querySelector('[data-story-prev]').addEventListener('click', function () { if (swiped) { swiped = false; return; } go(idx - 1, true); });
    index.forEach(function (b, k) { b.addEventListener('click', function () { go(k, true); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { userPaused = !userPaused; paint(); });
    /* the current bar fills in CSS; when it's full, move on (and stop on the last card) */
    bars.forEach(function (b, k) {
      b.addEventListener('animationend', function () {
        if (k !== idx || !playing()) return;
        if (idx < n - 1) go(idx + 1, false); else { ended = true; b.classList.add('done'); paint(); }
      });
    });
    /* a swipe moves the story too */
    var sr = 0;
    track.addEventListener('scroll', function () {
      if (sr) return;
      sr = requestAnimationFrame(function () {
        sr = 0;
        if (Date.now() - syncing < 700) return;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx) { idx = Math.max(0, Math.min(n - 1, i)); ended = false; setBars(); paint(); }
      });
    }, { passive: true });
    /* press and hold pauses, like every story you've ever watched (held is set on the tap zones above) */
    /* keyboard focus inside pauses it; a tap's focus doesn't */
    st.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (x) {}
      if (kb) { focused = true; paint(); }
    });
    st.addEventListener('focusout', function (e) { if (!st.contains(e.relatedTarget)) { focused = false; paint(); } });
    st.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); if (idx < n - 1) go(idx + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
    });
    doc.addEventListener('visibilitychange', paint);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { inView = en.isIntersecting && en.intersectionRatio >= 0.55; });
        paint();
      }, { threshold: [0, 0.55, 1] }).observe(st);
    }
    window.addEventListener('resize', function () { track.scrollLeft = idx * track.clientWidth; });
    setBars();
    paint();
  });

  /* ---- The buy box: form (and on hormones, him or her), plan, price, Buy now.
     One state per box. The first box on the page also drives everything outside any box:
     the receipt, the sticky bar, the CTA and every Buy now. Buy now goes to the product
     with the plan already picked (?selling_plan=). ---- */
  $$('[data-offer]').forEach(function (box, n) {
    var primary = n === 0;
    var forms = $$('[data-o-form]', box);
    if (!forms.length) return;
    function mine(sel) {
      return $$(sel).filter(function (el) { var b = el.closest('[data-offer]'); return b ? b === box : primary; });
    }
    var stage = box.querySelector('[data-o-stage]');
    var shots = stage ? Array.prototype.slice.call(stage.children) : [];
    var auds = $$('[data-o-aud]', box);
    /* two questions when a treatment comes in more than one form: the treatment row, then the form row */
    var kinds = $$('[data-o-kind]', box);
    var formRow = box.querySelector('[data-o-formrow]');
    var FORMKEYS = { name: 1, blurb: 1, p30: 1, p90: 1, pm90: 1, save: 1, saveamt: 1 };
    var aud0 = auds.filter(function (a) { return a.getAttribute('aria-selected') === 'true'; })[0] || auds[0];
    var state = {
      form: forms.filter(function (f) { return f.getAttribute('aria-checked') === 'true'; })[0] || forms[0],
      plan: '30',
      aud: aud0 ? aud0.getAttribute('data-o-aud') : null
    };
    function grpOf(el) { return el.getAttribute('data-group') || ''; }
    function kindOf(el) { return el.getAttribute('data-kind') || ''; }
    function inAud(el) { var g = grpOf(el); return !state.aud || !g || g === state.aud; }
    function has90(f) { return !!f.getAttribute('data-p90'); }
    function value(key, el) {
      var f = state.form;
      if (key === 'price' || key === 'total') return f.getAttribute(state.plan === '90' ? 'data-p90' : 'data-p30');
      if (FORMKEYS[key]) return f.getAttribute('data-' + key) || '';
      var lab = el.closest('[data-o-labels]');
      return lab ? lab.getAttribute('data-' + key + '-' + state.plan) : null;
    }
    function buyUrl() {
      var f = state.form, u = f.getAttribute('data-url') || '#', sp = f.getAttribute('data-sp90');
      if (state.plan === '90' && sp) u += (u.indexOf('?') > -1 ? '&' : '?') + 'selling_plan=' + sp;
      return u;
    }
    function render() {
      var f = state.form, i = +f.getAttribute('data-i') || 0;
      if (state.plan === '90' && !has90(f)) state.plan = '30';
      forms.forEach(function (o) { var on = o === f; o.setAttribute('aria-checked', String(on)); o.tabIndex = on ? 0 : -1; });
      if (kinds.length) {
        var kf = kindOf(f), gf = grpOf(f), counts = {}, multi = false;
        kinds.forEach(function (k) {
          var vis = inAud(k), on = vis && k.getAttribute('data-o-kind') === kf && grpOf(k) === gf;
          k.hidden = !vis; k.setAttribute('aria-checked', String(on)); k.tabIndex = on ? 0 : -1;
        });
        forms.forEach(function (o) {
          var vis = inAud(o), key = grpOf(o) + '::' + kindOf(o);
          if (vis) { counts[key] = (counts[key] || 0) + 1; if (counts[key] > 1) multi = true; }
          o.hidden = !(vis && kindOf(o) === kf && grpOf(o) === gf);
        });
        if (formRow) formRow.hidden = !multi;
      } else {
        forms.forEach(function (o) { o.hidden = !inAud(o); });
      }
      shots.forEach(function (im, k) {
        var on = k === i;
        if (on && im.loading === 'lazy') im.loading = 'eager';
        im.classList.toggle('on', on);
      });
      mine('[data-o-plan]').forEach(function (b) {
        var p = b.getAttribute('data-o-plan'), on = p === state.plan;
        b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1;
        if (p === '90') b.setAttribute('aria-disabled', String(!has90(f)));
      });
      mine('[data-o]').forEach(function (el) {
        var v = value(el.getAttribute('data-o'), el);
        if (v != null && el.textContent !== v) el.textContent = v;
      });
      mine('[data-o-when]').forEach(function (el) { el.hidden = el.getAttribute('data-o-when') !== state.plan; });
      var u = buyUrl();
      mine('[data-o-buy]').forEach(function (a) { a.setAttribute('href', u); });
    }
    function setAud(key, focus) {
      if (!auds.some(function (a) { return a.getAttribute('data-o-aud') === key; })) return;
      state.aud = key;
      auds.forEach(function (a) {
        var on = a.getAttribute('data-o-aud') === key;
        a.setAttribute('aria-selected', String(on)); a.tabIndex = on ? 0 : -1;
        if (on && focus) a.focus();
      });
      if (!inAud(state.form)) {
        var first = forms.filter(inAud)[0];
        if (first) state.form = first;
      }
      render();
    }
    /* a treatment: keep the same form if it comes that way (troche to troche), else its first form */
    function pickKind(k) {
      var want = k.getAttribute('data-o-kind'), g = grpOf(k);
      var cands = forms.filter(function (o) { return inAud(o) && kindOf(o) === want && grpOf(o) === g; });
      if (!cands.length) return;
      var cur = state.form.getAttribute('data-flabel');
      state.form = cands.filter(function (o) { return o.getAttribute('data-flabel') === cur; })[0] || cands[0];
      render();
    }
    /* arrow keys move the pick inside a radiogroup or tablist, like native controls */
    function arrows(e, list, pick) {
      var vis = list.filter(function (b) { return !b.hidden && b.getAttribute('aria-disabled') !== 'true'; });
      var i = vis.indexOf(doc.activeElement), m = vis.length, j = -1;
      if (i < 0) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % m;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + m) % m;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = m - 1;
      if (j < 0) return;
      e.preventDefault();
      pick(vis[j]);
      vis[j].focus();
    }
    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var f = t.closest('[data-o-form]'), p = t.closest('[data-o-plan]'), a = t.closest('[data-o-aud]'), k = t.closest('[data-o-kind]');
      var hit = f || p || a || k;
      var owner = hit ? hit.closest('[data-offer]') : null;
      if (owner ? owner !== box : !primary) return;
      if (k) { pickKind(k); }
      else if (f) { state.form = f; render(); }
      else if (p) { if (p.getAttribute('aria-disabled') === 'true') return; state.plan = p.getAttribute('data-o-plan'); render(); }
      else if (a) { setAud(a.getAttribute('data-o-aud')); }
    });
    var formsGroup = box.querySelector('[data-o-forms]');
    if (formsGroup) formsGroup.addEventListener('keydown', function (e) { arrows(e, forms, function (b) { state.form = b; render(); }); });
    var kindsGroup = box.querySelector('[data-o-kinds]');
    if (kindsGroup) kindsGroup.addEventListener('keydown', function (e) { arrows(e, kinds, pickKind); });
    mine('[data-o-plans]').forEach(function (g) {
      var list = $$('[data-o-plan]', g);
      g.addEventListener('keydown', function (e) { arrows(e, list, function (b) { state.plan = b.getAttribute('data-o-plan'); render(); }); });
    });
    var audList = box.querySelector('[data-o-auds]');
    if (audList) audList.addEventListener('keydown', function (e) { arrows(e, auds, function (b) { setAud(b.getAttribute('data-o-aud')); }); });
    function audFromHash() {
      var h = (location.hash || '').slice(1);
      if (!h) return;
      auds.forEach(function (a) { if (a.getAttribute('data-hash') === h) setAud(a.getAttribute('data-o-aud')); });
    }
    window.addEventListener('hashchange', audFromHash);
    audFromHash();
    render();
  });

  tabFromHash();
  openFromHash();
})();

/* =====================================================================
   First-party attribution (Oct 17)
   Private cart attributes (underscore keys are hidden at checkout) that carry
   onto the order, so every order placed on this theme says what it converted
   on. Nothing goes anywhere but this store's own cart.
     _pl_site    site version, the A/B arm. Orders from the old theme have none.
     _pl_land    first page of the visit
     _pl_src     utm source / medium / campaign / content, else the referring
                 site, else direct
     _pl_cta     the last button or link toward a product or the quiz:
                 page > section > label (the popup's ?entry=popup redirect
                 counts: page > popup > /pages/quiz)
     _pl_add     the control that added it: product page, sticky bar, add-on,
                 quiz, quick view
     _pl_device  phone or desktop
     _pl_mode    night or day at the add
     _pl_visits  visits so far, this one included
     _pl_days    days since the first visit
   Written after every add to cart (fetch or XHR, whichever script does it)
   and on page load when the cart has items but no _pl_site yet, always on its
   own: never at the same moment as another cart write (see run() below).
   A visitor who hits Decline on the cookie bar (or whose Shopify privacy
   setting says no analytics) isn't tracked: nothing is recorded about the
   visit and the cart gets _pl_site only, so the order still counts in its arm.
   ===================================================================== */
(function () {
  'use strict';
  var SITE = 'r17';
  var doc = document, ls = null, ss = null;
  try { ls = window.localStorage; ss = window.sessionStorage; } catch (e) {}
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) {} }
  function clip(v, n) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().slice(0, n || 120); }
  function host(u) { try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }
  // the cookie bar's Decline, or Shopify's own privacy setting saying no analytics
  function declined() {
    if (get(ls, 'localCookie') === 'decline') return true;
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; if (cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed() === false) return true; } catch (e) {}
    return false;
  }

  // a visit starts when this tab has no record yet
  if (!declined() && !get(ss, 'pl-v-land')) {
    var q = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (p) {
      var i = p.indexOf('='); if (i < 1) return;
      try { q[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1).replace(/\+/g, ' ')); } catch (e) {}
    });
    var utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map(function (k) { return clip(q[k], 60); });
    var src = utm[0] ? utm.filter(Boolean).join(' / ') : '';
    if (!src) {
      var ref = doc.referrer ? host(doc.referrer) : '', me = location.hostname.replace(/^www\./, '');
      src = ref && ref !== me ? 'ref: ' + ref : 'direct';
    }
    if (q.gclid) src += ' (gclid)';
    if (q.fbclid) src += ' (fbclid)';
    set(ss, 'pl-v-land', clip(location.pathname, 120));
    set(ss, 'pl-v-src', clip(src, 200));
    set(ls, 'pl-visits', String((parseInt(get(ls, 'pl-visits'), 10) || 0) + 1));
    if (!get(ls, 'pl-first')) set(ls, 'pl-first', String(Date.now()));
  }
  // the signup popup sends people to the quiz as ?entry=popup, a redirect rather than a link click, so it's recorded
  // here as the button they came through: page they were on > popup > page it opened
  var entry = /[?&]entry=([^&#]+)/.exec(location.search);
  if (entry && !declined()) {
    var from = '';
    try { if (doc.referrer && host(doc.referrer) === location.hostname.replace(/^www\./, '')) from = new URL(doc.referrer).pathname; } catch (e) {}
    var ev = entry[1]; try { ev = decodeURIComponent(ev.replace(/\+/g, ' ')); } catch (e) {}
    set(ss, 'pl-v-cta', clip((from || 'unknown page') + ' > ' + clip(ev, 30) + ' > ' + location.pathname, 160));
  }

  function sectionOf(el) {
    var s = el.closest('[id^="shopify-section-"]');
    if (!s) return el.closest('header') ? 'header' : el.closest('footer') ? 'footer' : el.closest('.mini-cart-content') ? 'cart drawer' : 'page';
    return s.id.replace(/^shopify-section-/, '').replace(/^(template|sections)--\d+__/, '');
  }
  function labelOf(el) { return clip(el.getAttribute('aria-label') || el.textContent || el.value, 40); }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    // Decline on the cookie bar: forget this browser's visit record and strip the details already on the cart
    if (t && t.closest && t.closest('.js-btn-decline')) {
      try { ['pl-visits', 'pl-first'].forEach(function (k) { ls.removeItem(k); }); ['pl-v-land', 'pl-v-src', 'pl-v-cta', 'pl-v-add'].forEach(function (k) { ss.removeItem(k); }); } catch (x) {}
      setTimeout(recheck, 400);
      return;
    }
    // only real clicks: the sticky bar's button clicks the product form's button in script, and that must not overwrite it
    if (!t || !t.closest || e.isTrusted === false || declined()) return;
    var a = t.closest('a[href*="/products/"], [data-o-buy], a[href*="/pages/quiz"]');
    if (a) set(ss, 'pl-v-cta', clip(location.pathname + ' > ' + sectionOf(a) + ' > ' + labelOf(a), 160));
    var via = t.closest('#js-sticky-btn, .sticky-cart-wr [type="submit"]') ? 'sticky bar'
      : t.closest('.pluto-addon') && t.closest('button, [type="submit"]') ? 'add-on'
      : t.closest('#pl-quiz') && t.closest('button') ? 'quiz'
      : t.closest('#fbt-button') ? 'bought together'
      : t.closest('.quickview, .modal-quickview, [class*="quick-view"], [class*="quickview"]') && t.closest('button, [type="submit"]') ? 'quick view'
      : t.closest('form[action*="/cart/add"]') && t.closest('button, [type="submit"]') ? 'product page' : '';
    if (via) set(ss, 'pl-v-add', via);
  }, true);

  function attrs() {
    // declined: the arm only, and empty values clear anything written before the Decline
    if (declined()) return { _pl_site: SITE, _pl_land: '', _pl_src: '', _pl_cta: '', _pl_add: '', _pl_device: '', _pl_mode: '', _pl_visits: '', _pl_days: '' };
    var first = parseInt(get(ls, 'pl-first'), 10) || Date.now();
    return {
      _pl_site: SITE,
      _pl_land: get(ss, 'pl-v-land') || clip(location.pathname, 120),
      _pl_src: get(ss, 'pl-v-src') || 'direct',
      _pl_cta: get(ss, 'pl-v-cta') || '',
      _pl_add: get(ss, 'pl-v-add') || '',
      _pl_device: window.matchMedia && window.matchMedia('(max-width: 899px)').matches ? 'phone' : 'desktop',
      _pl_mode: doc.documentElement.getAttribute('data-mode') || '',
      _pl_visits: get(ls, 'pl-visits') || '1',
      _pl_days: String(Math.max(0, Math.floor((Date.now() - first) / 864e5)))
    };
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  // Shopify keeps only one of two cart writes that land at the same moment, so ours never overlaps another:
  // it waits until no other cart write is in flight and the cart has been quiet for QUIET ms, and any cart
  // write that starts while ours is in flight waits for ours to finish.
  var QUIET = 500, busy = 0, mine = null, want = false, timer = 0, tries = 0;
  function isWrite(u) { return /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(String(u || '')); }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  function later() { if (!want) return; clearTimeout(timer); timer = setTimeout(run, QUIET); }
  function ask() { want = true; tries = 0; later(); }
  function run() {
    if (!want || mine || !nativeFetch) return;
    if (busy > 0) return later();
    want = false; tries++;
    // keepalive: the write still lands if the shopper heads to checkout right as it goes out
    mine = nativeFetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs() })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if ((!c || !c.attributes || c.attributes._pl_site !== SITE) && tries < 3) want = true; }, function () { if (tries < 3) want = true; })
      .then(function () { mine = null; later(); });
  }

  // see every cart write, whichever script makes it
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isWrite(url)) return nativeFetch(input, init);
      function go() {
        busy++;
        var p = nativeFetch(input, init);
        p.then(function (r) { busy--; if (isAdd(url) && r && r.ok) ask(); else later(); }, function () { busy--; later(); });
        return p;
      }
      return mine ? mine.then(go, go) : go();
    };
  }
  var XP = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (XP) {
    var xOpen = XP.open, xSend = XP.send;
    XP.open = function (m, u, async) { this.__plW = isWrite(u); this.__plA = isAdd(u); this.__plSync = async === false; return xOpen.apply(this, arguments); };
    XP.send = function () {
      var x = this, args = arguments;
      if (!x.__plW) return xSend.apply(x, args);
      function go() {
        busy++;
        x.addEventListener('loadend', function () { busy--; if (x.__plA && x.status >= 200 && x.status < 300) ask(); else later(); });
        return xSend.apply(x, args);
      }
      if (mine && !x.__plSync) { mine.then(go, go); return; }
      return go();
    };
  }

  // a cart with items but no _pl_site (a full-page add, or carted before this code) gets it on the next page,
  // and a visitor who declined loses any details written before the Decline
  function recheck() {
    if (!nativeFetch) return;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !(c.item_count > 0)) return;
        var a = c.attributes || {};
        if (a._pl_site !== SITE || (declined() && a._pl_src)) ask();
      })
      .catch(function () {});
  }
  var countEl = doc.querySelector('.js-cart-count');
  var count = countEl ? parseInt(countEl.textContent, 10) : NaN;
  if (count !== 0) recheck();
})();
